import { Injectable } from '@angular/core';
import { EMAIL_WHITELIST_CONFIG, getEmailWhitelist } from '../config/email-whitelist.config';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ApprovedUsersService {
  // List of approved email addresses loaded from configuration
  private approvedEmails: string[];

  constructor() {
    // Load emails from configuration, including dev emails if in development mode
    this.approvedEmails = getEmailWhitelist(!environment.production);
  }

  /**
   * Check if an email address is in the approved list
   * @param email - The email address to check
   * @returns boolean - True if email is approved, false otherwise
   */
  isEmailApproved(email: string): boolean {
    if (!email) {
      return false;
    }
    
    let normalizedEmail = email;
    let normalizedApprovedEmails = this.approvedEmails;
    
    // Apply trimming if configured
    if (EMAIL_WHITELIST_CONFIG.trimWhitespace) {
      normalizedEmail = normalizedEmail.trim();
      normalizedApprovedEmails = normalizedApprovedEmails.map(e => e.trim());
    }
    
    // Apply case sensitivity if configured
    if (!EMAIL_WHITELIST_CONFIG.caseSensitive) {
      normalizedEmail = normalizedEmail.toLowerCase();
      normalizedApprovedEmails = normalizedApprovedEmails.map(e => e.toLowerCase());
    }
    
    return normalizedApprovedEmails.includes(normalizedEmail);
  }

  /**
   * Get the list of approved emails (for admin purposes)
   * @returns string[] - Array of approved email addresses
   */
  getApprovedEmails(): string[] {
    return [...this.approvedEmails]; // Return a copy to prevent direct modification
  }

  /**
   * Add an email to the approved list
   * @param email - The email address to add
   */
  addApprovedEmail(email: string): void {
    if (email && !this.isEmailApproved(email)) {
      this.approvedEmails.push(email.toLowerCase().trim());
    }
  }

  /**
   * Remove an email from the approved list
   * @param email - The email address to remove
   */
  removeApprovedEmail(email: string): void {
    const normalizedEmail = email.toLowerCase().trim();
    this.approvedEmails = this.approvedEmails.filter(
      approvedEmail => approvedEmail.toLowerCase().trim() !== normalizedEmail
    );
  }
}